import React from "react";
import { SectionHeader } from "../components/section-header";
import { AppDownload } from "@/components/features/app-download";

interface AppDownloadSectionProps {}

export function AppDownloadSection() {
  return (
    <section className="border-b border-border bg-neutral-50/50" aria-labelledby="app-download-heading">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <div className="max-w-2xl mx-auto text-center">
          <h2 id="app-download-heading" className="font-display text-2xl font-semibold tracking-tight text-foreground">
            Download the HRShakti App
          </h2>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-md mx-auto">
            Get real-time updates, save articles, join discussions, and connect with HR professionals — all on the go.
          </p>
          <AppDownload />
        </div>
      </div>
    </section>
  );
}